<template>
  <div class="h-100">
    <cc-sidebar ref="sidebarRightFilter" id="sidebar-right-filter"
                title="Điều kiện tìm kiếm"
                @onOpenedSidebar="onOpenedSidebar">
      <template slot="body">
        <filter-panel ref="filterPanel"></filter-panel>
      </template>
      <template slot="footer">
        <div class="align-items-center p-3">
          <CRow>
            <CCol :col="{size: 10, offset: 1}">
              <CRow>
                <CCol col="6">
                  <CButton block color="danger" size="sm" @click="resetCondition">Xóa điều kiện</CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="success" size="sm" @click="filterListWithCondition">Tìm kiếm</CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </template>
    </cc-sidebar>
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <CCard accent-color="warning" class="h-100">
          <CCardHeader class="px-3">
            <CRow>
              <CCol col="6">
                <h4 class="text-uppercase my-0">Logs hệ thống</h4>
              </CCol>
              <CCol col="6" class="float-right">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol col="10" class="text-right text-success pt-1 px-0">
                        <i>Time get logs: <b class="text-danger">{{ timeGetLog }}</b></i>
                      </CCol>
                      <CCol col="2" class="text-center align-self-center" style="padding-top: 2px">
                        <CLink href="#" v-b-toggle.sidebar-right-filter>
                          <CIcon name="cil-filter" height="20"/>
                        </CLink>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <codemirror v-model="logData" :options="cmOptions" class="h-100 cm-main"></codemirror>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import {COMMON, LOG_TEXT_MAPPING} from '@/common/Constant'
import {mapActions, mapState} from 'vuex'
import CcSidebar from '@/components/common/CcSidebar'
import FilterPanel from '@/components/log/FilterPanel'
import {format} from '@/mixins/format'
import moment from 'moment'

export default {
  name: "List",
  components: {
    CcSidebar,
    FilterPanel
  },
  mixins: [
    format
  ],
  data() {
    return {
      logData: '',
      cmOptions: COMMON.codeMirror.options,
      timeGetLog: ''
    }
  },
  created() {
    this.logData = COMMON.codeMirror.logData.header + '/...No log...\n\n' + COMMON.codeMirror.logData.footer
  },
  async mounted() {
    await this.initData()
  },
  computed: {
    ...mapState('log', ['logList'])
  },
  methods: {
    ...mapActions('log', ['getLogList']),
    async initData() {
      let logTextBody = '/...No log...\n\n'
      await this.getLogList(this.$refs.filterPanel.filterMap)
      this.timeGetLog = moment().format('YYYY-MM-DD | HH:mm:ss A')
      if (this.logList && this.logList.length) {
        logTextBody = ''
        this.logList.forEach(logItem => {
          const logTextMappingItem = LOG_TEXT_MAPPING[logItem.action]
          logTextBody += `#${moment(logItem.datetime).format('YYYY-MM-DD HH:mm:ss')} | @user_id: ${logItem.user_id}\n`
          if (logTextMappingItem && Object.keys(logTextMappingItem).length > 0) {
            if (logTextMappingItem.isDisplayValue) {
              if (logItem.action === 7) {
                if (Number(logItem.value) === 0) {
                  logTextBody += `$_message: "${logTextMappingItem.name}" ===> "gửi tất cả".\n\n`
                } else {
                  logTextBody += `$_message: "${logTextMappingItem.name}"\n\n`
                }
              } else {
                logTextBody += `$_message: "${logTextMappingItem.name}" <${logTextMappingItem.value} ${this.fNumber(logItem.value)}>\n\n`
              }
            } else {
              logTextBody += `$_message: "${logTextMappingItem.name}"\n\n`
            }
          } else {
            logTextBody += `$_message: "${logItem.message}"\n\n`
          }
        })
      }
      this.logData = COMMON.codeMirror.logData.header + logTextBody + COMMON.codeMirror.logData.footer
    },
    onOpenedSidebar() {
      this.$refs.filterPanel.getUserListWhenOpenSidebar()
    },
    resetCondition() {
      this.$refs.filterPanel.resetCondition()
    },
    async filterListWithCondition() {
      this.$refs.sidebarRightFilter.$refs.ccSidebar.hide()
      await this.initData()
    }
  }
}
</script>

<style scoped>

</style>
